import styled from 'styled-components';

import { COLORS, STYLES } from 'apps/web_forms/utils/constants';

export const CustomSelectContainer = styled.div`
  position: relative;
  display: inline-block;

  select {
    outline: none;
    appearance: none;
    display: block;
    padding: 0 0 0 0.6em;
    margin: 0;

    transition: border-color 0.2s;
    border: 1px solid ${COLORS.borderGrey};

    background: ${COLORS.inputBackgroundColor};
    line-height: normal;
    font-family: inherit;
    font-size: inherit;
    min-width: 6em;
    height: 2em;
    border-radius: 0;
    box-sizing: unset;

    &.select-input.invalid {
      border: ${STYLES.ErrorHighlight};
    }
    &.select-input.updateHighlight {
      border: ${STYLES.UpdateHighlight};
    }
  }
  .arrow-icon {
    position: absolute;
    top: calc(50% - 0.35em);
    right: 0.8em;
    transform: rotate(-90deg);
    width: 0.75em;
    height: 0.75em;
    pointer-events: none;
  }
  .boolean-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.4em;
    label {
      display: flex;
      align-items: center;
      margin-right: 0.4em;
    }

    .select-boolean-label {
      font-size: 0.9em;
    }

    @supports (-webkit-appearance: none) or (-moz-appearance: none) {
      input[type='radio'] {
        -webkit-appearance: none;
        -moz-appearance: none;
        border: 1px solid ${COLORS.borderBooleanRadio};
        outline: none;
        transition: box-shadow 0.2s;
        border-radius: 50%;
        width: 1.25em;
        height: 1.25em;
        margin-right: 0.4em;
        background-color: ${COLORS.booleanInputBackgroundColor};
        cursor: default;
        position: relative;
        top: -0.1em;

        &:checked {
          background-color: ${COLORS.green};
        }

        &:required:invalid {
          border: ${STYLES.ErrorHighlight};
        }
        &:required:updatehighlight {
          border: ${STYLES.UpdateHighlight};
        }
      }

      input[readonly].read-only {
        background-color: ${COLORS.readOnlyBooleanInputBackgroundColor};

        &:checked {
          background-color: ${COLORS.darkGreen};
        }
      }
    }
  }

  input[type='text'] {
    height: auto !important;
  }
`;
